module.exports = {
    validators: {
        avatars: {},
    },
};
